const ADMIN_TAB_ACCESS = ["testing1@gmail.com", "amitpatel321@gmail.com"];

export default { ADMIN_TAB_ACCESS };
